import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';

import { useDisabledState } from 'common/disabled-context';
import { AuthContext } from 'core/components/auth';
import { SchedulePP } from 'common/components/schedule-pp';
import { Umbrella } from 'common/components/umbrella';
import { AddInterestedPartyForm, InterestedParty } from 'common/components/people';
import FormList from 'core/components/form-list';
import { HomeCoverage, Additionals } from './coverages';
import Detail from './detail';

function HomeOffer() {
  const { disabled } = useDisabledState();
  const { viewOnly } = useContext(AuthContext);
  const { values } = useFormikContext();
  const {
    homeCoverage: { coverageX, coverageCPctOfA, coverageA },
    home: {
      homeLocation: { state }
    }
  } = values;

  const sppLimits = {
    tenPctOfCoverageC: coverageA * (coverageCPctOfA / 100) * 0.1,
    fiftyPctOfCoverageC: coverageA * (coverageCPctOfA / 100) * 0.5
  };

  return (
    <>
      <Detail disabled={disabled} />
      <HomeCoverage disabled={disabled} />
      <SchedulePP disabled={disabled} sppLimits={sppLimits} />
      <FormList
        key={`parties-${disabled}`}
        id="interestedParties"
        item={InterestedParty}
        addForm={AddInterestedPartyForm}
        title="Additional interested party"
        addLabel="Add People"
        disabled={disabled || viewOnly}
      />
      <Umbrella disabled={disabled} state={state} coverageX={coverageX} />
      <Additionals disabled={disabled} />
    </>
  );
}

export default observer(HomeOffer);
